export const events = [
  {
    id: 1,
    title: "Weekly Project Meetings",
    type: "Meeting",
    date: "Weekly",
    time: "Team Dependent",
    location: "MUSIC 265 / Online",
    description:
      "If you have been accepted to a WCO Project Team, attend weekly meetings to collaborate with your team members, discuss project progress, and work towards achieving your project goals.",
    status: "upcoming",
    learnMore:
      "https://docs.google.com/forms/d/e/1FAIpQLSfqb9YMJvKk5xndeUM6NpKmzShYeH6pg-jTo_Njry-WPV5MNA/viewform?usp=dialog",
  },
];

/**
 * 
 * EXAMPLE DATA - DO NOT DELETE
 * 
 * {
    id: 2,
    title: "Monthly Club Meeting",
    type: "Meeting",
    date: "2024-02-20",
    time: "7:00 PM - 8:30 PM",
    location: "TBD",
    description:
      "General club meeting to discuss upcoming events and member updates.",
    status: "upcoming",
  },
  {
    id: 3,
    title: "Personal Portfolio Workshop",
    type: "Workshop",
    date: "10/1/2025",
    time: "5:30 PM - 7:30 PM",
    location: "TBD",
    description:
      "Introduction to React and how to build your personal portfolio website to showcase your work.",
    status: "upcoming",
  },
  {
    id: 4,
    title: "Interview Workshop",
    type: "Workshop",
    date: "09/15/2025",
    time: "6:30 PM - 8:00 PM",
    location: "TBD",
    description:
      "Prepare for the upcoming tech interviews with resume reviews and interview tips.",
    status: "upcoming",
  },
 */
